module.exports = __webpack_public_path__ + "img/ring_y_s_null_null.f3c0c0c0.png";